export const STATUS_META = {
  scheduled:    { label: "SCHEDULED",  color: "bg-zinc-700",     text: "text-zinc-200", dot: "bg-zinc-400" },
  ping_sent:    { label: "PINGED",     color: "bg-blue-600/30",  text: "text-blue-300", dot: "bg-blue-400" },
  arrived:      { label: "ON POST",    color: "bg-emerald-700/30",text: "text-emerald-300", dot: "bg-emerald-400" },
  late:         { label: "LATE",       color: "bg-yellow-600/30",text: "text-yellow-300", dot: "bg-yellow-400 pulse-warn" },
  no_show:      { label: "NO SHOW",    color: "bg-red-700/30",   text: "text-red-300",  dot: "bg-red-500 pulse-critical" },
  cant_make_it: { label: "DECLINED",   color: "bg-red-700/30",   text: "text-red-300",  dot: "bg-red-500" },
  completed:    { label: "COMPLETED",  color: "bg-zinc-800",     text: "text-zinc-300", dot: "bg-zinc-500" },
};

const StatusBadge = ({ status, testid }) => {
  const meta = STATUS_META[status] || STATUS_META.scheduled;
  return (
    <span
      data-testid={testid || `status-${status}`}
      className={`inline-flex items-center gap-2 px-2 py-1 ${meta.color} ${meta.text} text-[0.65rem] font-mono uppercase tracking-wider rounded-sm`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
};

export default StatusBadge;
